import type { components } from './types';

export type ErroData = components['schemas']['ErroData'];
export type ErroCampo = components['schemas']['ErroCampo'];
export type Passo = components['schemas']['Passo'];

/**
 * Erro normalizado da API. Todo caminho de falha do cliente (`client.ts`) termina
 * aqui, para que a UI decida sempre por `code` (`src/app/errors.ts`, matriz FR-123)
 * e nunca pela mensagem do servidor.
 */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly data: ErroData;
  /** `message` que o backend mandou (para humano), quando houver. */
  readonly serverMessage: string;

  constructor(args: { code: string; message: string; status: number; data?: ErroData | null }) {
    super(args.message);
    this.name = 'ApiError';
    this.code = args.code;
    this.status = args.status;
    this.data = args.data ?? {};
    this.serverMessage = args.message;
  }

  /** Erros de validação local (422 `dados_invalidos`) por campo. */
  get campos(): ErroCampo[] {
    return this.data.fields ?? [];
  }

  /** Passos que o middleware executou (envelope das ordens). */
  get passos(): Passo[] {
    return this.data.steps ?? [];
  }

  /** `false` quando o middleware pode ter deixado estado parcial (`estado_parcial`). */
  get desfeito(): boolean | null {
    return this.data.undone ?? null;
  }

  get isSessionExpired(): boolean {
    return this.code === 'sessao_expirada' || this.code === 'nao_autenticado';
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}
